import _slicedToArray from "C:/Users/gilbe/OneDrive/Documents/GitHub/luth-main/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useRef, useEffect } from 'react';
import { getLockStyles } from './utils/get-lock-styles.js';
import { injectStyles } from './utils/inject-style-tag.js';
import { insertStyleTag } from './utils/insert-style-tag.js';
import { makeStyleTag } from './utils/make-style-tag.js';

function useScrollLock(lock) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    disableBodyPadding: false
  };

  var _useState = useState(lock || false),
      _useState2 = _slicedToArray(_useState, 2),
      scrollLocked = _useState2[0],
      setScrollLocked = _useState2[1];

  var scrollTop = useRef(0);
  var disableBodyPadding = options.disableBodyPadding;
  var stylesheet = useRef(null);

  var lockScroll = function lockScroll() {
    scrollTop.current = window.scrollY;
    var styles = getLockStyles({
      disableBodyPadding: disableBodyPadding
    });
    var sheet = makeStyleTag();
    injectStyles(sheet, styles);
    insertStyleTag(sheet);
    stylesheet.current = sheet;
  };

  var unlockScroll = function unlockScroll() {
    if (!(stylesheet == null ? void 0 : stylesheet.current)) return;
    stylesheet.current.parentNode.removeChild(stylesheet.current);
    stylesheet.current = null;
  };

  useEffect(function () {
    if (scrollLocked) {
      lockScroll();
    } else {
      unlockScroll();
    }

    return unlockScroll;
  }, [scrollLocked]);
  useEffect(function () {
    if (lock !== void 0) {
      setScrollLocked(lock);
    }
  }, [lock]);
  useEffect(function () {
    if (lock === void 0 && typeof window !== "undefined") {
      window.document.body.style.overflow === "hidden" && setScrollLocked(true);
    }
  }, [setScrollLocked]);
  return [scrollLocked, setScrollLocked];
}

export { useScrollLock };